import { NetworkStatus } from '@apollo/client';

export const DEFAULT_VOID_APOLLO_RESULT = {
  data: null,
  loading: false,
  networkStatus: NetworkStatus.ready,
  stale: false,
};
